<script setup lang="ts">
import type { SalesforceFormValues } from './types';

defineProps<{
  values: SalesforceFormValues;
  returnPath: string;
  submitUrl: string;
  oid: string;
}>();
</script>

<template>
  <meta HTTP-EQUIV="Content-type" CONTENT="text/html; charset=UTF-8">

  <form :action="submitUrl" method="POST">
    <input type="hidden" name="oid" :value="oid">
    <input type="hidden" name="retURL" :value="returnPath">

    <label for="first_name">First Name</label>
    <input
      id="first_name"
      :value="values.firstName"
      maxlength="40"
      name="first_name"
      size="20"
      type="text"
    ><br>

    <label for="last_name">Last Name</label>
    <input
      id="last_name"
      :value="values.lastName"
      maxlength="80"
      name="last_name"
      size="20"
      type="text"
    ><br>

    <label for="email">Email</label>
    <input
      id="email"
      :value="values.emailAddress"
      maxlength="80"
      name="email"
      size="20"
      type="text"
    ><br>

    <label for="company">Company</label>
    <input
      id="company"
      :value="values.companyName"
      maxlength="40"
      name="company"
      size="20"
      type="text"
    ><br>

    <label for="phone">Phone</label>
    <input
      id="phone"
      :value="values.phoneNumber"
      maxlength="40"
      name="phone"
      size="20"
      type="text"
    ><br>

    Country ID*:<select id="00N3X00000Jv5Rc" name="00N3X00000Jv5Rc" title="Country ID*">
      <option :value="values.countryCode">
        {{ values.countryCode }}
      </option>
      <option value="">
        --None--
      </option>
      <option value="AT">
        AT
      </option>
      <option value="AU">
        AU
      </option>
      <option value="BE">
        BE
      </option>
      <option value="CA">
        CA
      </option>
      <option value="CH">
        CH
      </option>
      <option value="CZ">
        CZ
      </option>
      <option value="DE">
        DE
      </option>
      <option value="DK">
        DK
      </option>
      <option value="ES">
        ES
      </option>
      <option value="FO">
        FO
      </option>
      <option value="FR">
        FR
      </option>
      <option value="GB">
        GB
      </option>
      <option value="IE">
        IE
      </option>
      <option value="IT">
        IT
      </option>
      <option value="LU">
        LU
      </option>
      <option value="NL">
        NL
      </option>
      <option value="NO">
        NO
      </option>
      <option value="PL">
        PL
      </option>
      <option value="PT">
        PT
      </option>
      <option value="SE">
        SE
      </option>
      <option value="US">
        US
      </option>
    </select><br>

    Inbound Campaign:
    <input
      id="00N3X00000Jv5Rk"
      :value="values.utmCampaign"
      maxlength="255"
      name="00N3X00000Jv5Rk"
      size="20"
      type="text"
    ><br>

    Inbound Medium:<select id="00N3X00000Jv5Rl" name="00N3X00000Jv5Rl" title="Inbound Medium">
      <option :value="values.utmMedium" selected>
        {{ values.utmMedium }}
      </option>
      <option value="">
        --None--
      </option>
      <option value="affiliate">
        affiliate
      </option>
      <option value="App">
        App
      </option>
      <option value="billboard">
        billboard
      </option>
      <option value="display">
        display
      </option>
      <option value="email">
        email
      </option>
      <option value="event">
        event
      </option>
      <option value="field">
        field
      </option>
      <option value="franchise">
        franchise
      </option>
      <option value="native">
        native
      </option>
      <option value="outofhome">
        outofhome
      </option>
      <option value="partnerships">
        partnerships
      </option>
      <option value="phone">
        phone
      </option>
      <option value="postal">
        postal
      </option>
      <option value="print">
        print
      </option>
      <option value="Radio">
        Radio
      </option>
      <option value="referral">
        referral
      </option>
      <option value="search">
        search
      </option>
      <option value="social">
        social
      </option>
      <option value="TV">
        TV
      </option>
      <option value="Word of mouth">
        Word of mouth
      </option>
    </select><br>

    Inbound Source:<select id="00N3X00000Jv5Rm" name="00N3X00000Jv5Rm" title="Inbound Source">
      <option :value="values.utmSource" selected>
        {{ values.utmSource }}
      </option>
      <option value="">
        --None--
      </option>
      <option value="amazon">
        amazon
      </option>
      <option value="ambassador">
        ambassador
      </option>
      <option value="apple search">
        apple search
      </option>
      <option value="awin">
        awin
      </option>
      <option value="billboard">
        billboard
      </option>
      <option value="bing">
        bing
      </option>
      <option value="blog">
        blog
      </option>
      <option value="edenred">
        edenred
      </option>
      <option value="event">
        event
      </option>
      <option value="facebook">
        facebook
      </option>
      <option value="flyer">
        flyer
      </option>
      <option value="google">
        google
      </option>
      <option value="google play search">
        google play search
      </option>
      <option value="instagram">
        instagram
      </option>
      <option value="linkedin">
        linkedin
      </option>
      <option value="medium">
        medium
      </option>
      <option value="newsletter">
        newsletter
      </option>
      <option value="optimise">
        optimise
      </option>
      <option value="pinterest">
        pinterest
      </option>
      <option value="quora">
        quora
      </option>
      <option value="referral">
        referral
      </option>
      <option value="snapchat">
        snapchat
      </option>
      <option value="tradedoubler">
        tradedoubler
      </option>
      <option value="twitter">
        twitter
      </option>
      <option value="unilever">
        unilever
      </option>
      <option value="youtube">
        youtube
      </option>
      <option value="waylink">
        waylink
      </option>
      <option value="metro">
        metro
      </option>
      <option value="bkd">
        bkd
      </option>
    </select><br>

    Inbound UTM Content:
    <input
      id="00N3X00000JCWV5"
      :value="values.utmContent"
      maxlength="255"
      name="00N3X00000JCWV5"
      size="20"
      type="text"
    ><br>

    Inbound UTM Term:
    <input
      id="00N3X00000JCWVA"
      :value="values.utmTerm"
      maxlength="255"
      name="00N3X00000JCWVA"
      size="20"
      type="text"
    ><br>

    Newsletter optin:
    <input
      id="00NTX000005XjOX"
      :value="values.optInNewsletter"
      name="00NTX000005XjOX"
    ><br>

    Privacy Policy Opt-in:
    <input
      id="00NTX000005XjOY"
      name="00NTX000005XjOY"
      :value="values.optInPrivacyPolicy"
    ><br>

    Accepted Marketing Cookies:
    <input
      id="00NTX000005XjOU"
      :value="values.acceptedMarketingCookies"
      name="00NTX000005XjOU"
    ><br>

    Facebook Click ID:
    <input
      id="00NTX000005XjOV"
      :value="values.facebookClickId"
      maxlength="100"
      name="00NTX000005XjOV"
      size="20"
      type="text"
    ><br>

    Google Click ID:
    <input
      id="00NTX000005XjOW"
      :value="values.googleClickId"
      maxlength="100"
      name="00NTX000005XjOW"
      size="20"
      type="text"
    ><br>

    Language:<select id="00NTX000005XjOT" name="00NTX000005XjOT" title="Language">
      <option :value="values.locale" selected>
        {{ values.locale }}
      </option>
      <option value="">
        --None--
      </option>
      <option value="da">
        da
      </option>
      <option value="de">
        de
      </option>
      <option value="de-at">
        de-at
      </option>
      <option value="de-ch">
        de-ch
      </option>
      <option value="en-au">
        en-au
      </option>
      <option value="en-ca">
        en-ca
      </option>
      <option value="en-gb">
        en-gb
      </option>
      <option value="en-ie">
        en-ie
      </option>
      <option value="en-us">
        en-us
      </option>
      <option value="es">
        es
      </option>
      <option value="fr">
        fr
      </option>
      <option value="fr-be">
        fr-be
      </option>
      <option value="fr-ca">
        fr-ca
      </option>
      <option value="fr-ch">
        fr-ch
      </option>
      <option value="it">
        it
      </option>
      <option value="it-ch">
        it-ch
      </option>
      <option value="nl">
        nl
      </option>
      <option value="nl-be">
        nl-be
      </option>
      <option value="no">
        no
      </option>
      <option value="pl">
        pl
      </option>
      <option value="pt">
        pt
      </option>
      <option value="sv">
        sv
      </option>
      <option value="jp">
        jp
      </option>
    </select><br>

    Product interest:<select id="00NTX000005HI2V" name="00NTX000005HI2V" title="Product interest">
      <option :value="values.productInbound" selected>
        {{ values.productInbound }}
      </option>
      <option value="">
        --None--
      </option>
      <option value="LOOK-SMELL-TASTE">
        LOOK-SMELL-TASTE
      </option>
      <option value="TOO GOOD TO GO PARCELS">
        TOO GOOD TO GO PARCELS
      </option>
      <option value="AI-POWERED DISCOUNTING">
        AI-POWERED DISCOUNTING
      </option>
      <option value="EXPIRY DATE MANAGEMENT+">
        EXPIRY DATE MANAGEMENT+
      </option>
      <option value="DONATIONS+ (BUSINESS)">
        DONATIONS+ (BUSINESS)
      </option>
      <option value="DONATIONS+ (CHARITY)">
        DONATIONS+ (CHARITY)
      </option>
    </select><br>

    TGTG Lead Source:
    <select id="00N3X00000Jv5Ro" name="00N3X00000Jv5Ro" title="TGTG Lead Source">
      <option value="Inbound" />
    </select>

    <label for="url">Website</label>
    <input
      id="url"
      maxlength="80"
      name="url"
      size="20"
      type="text"
      :value="values.websiteName"
    >

    <input id="htmlSubmitButton" type="submit" name="submit">
  </form>
</template>
